<template>
    <div class="header flex-between">
        <div v-if="this.$route.path=='/personalcenter'"
         class="goBack" v-preventReClick @click="back"><i class="el-icon-arrow-left"></i>返回</div>
        <div v-else class="logo">
            <img src="../../assets/img/logo-fill.png">
        </div>
        <div class="header-right">
            <div class="header-user-con">
                <div class="user" @click="toPersonalCenter">
                    <el-avatar :size="40" :src="avatar"></el-avatar>
                    <span class="user-avator">{{userName}}</span>
                </div>
                <el-divider class="ml20" direction="vertical"></el-divider>
                <el-button type="text" class="ml20" @click="loginout">退出</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import bus from '../common/bus';
export default {
    data() {
        return {
            userName: this.$store.state.userName,
            avatar: this.$store.state.avatar
        };
    },
    mounted(){
        bus.$on('updateAvatar',avatar => {
            this.avatar = avatar
        })
        bus.$on('updateAccount',userName => {
            this.userName = userName
        })
    },
    methods: {
        loginout() {
            this.$get(this.api.logout,{
                token:this.$store.state.token
            }).then(res => {
                this.$store.replaceState({})
                sessionStorage.clear()
                this.$router.push('/login')
            })
        }, 
        toPersonalCenter(){
          this.$router.push('/personalcenter')
        },
        back(){
            if(this.$route.path == '/addassessment'){
                this.$router.push({ path: '/teacherhome', query: { active: true }})
            }else{
                this.$router.go(-1)
            }
        }
    },
};
</script>
<style scoped lang="scss">
.goBack{
    cursor: pointer;
    line-height: 60px;
    height: 60px;
    font-size: 16px;
    font-weight: bold;
    margin-left: 20px;
}
.goBack i{
    color: #328aff;
    font-size: 20px;
}
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px;
    font-size: 16px;
    color: #333;
}
.header .logo {
    float: left;
    width: 170px;
    height: 40px;
    margin-left: 20px;
}
.header .logo img{
    width: 100%;
    height: 100%;
}
.header-right {
    float: right;
    padding-right: 50px;
}
.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;

    .user{
        display: inline-flex;
        align-items: center;
        cursor: pointer;
    }
}
.user-avator {
    margin-left: 10px;
}
.ml20{
    margin-left: 20px;
}
.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.header-right .el-button--text{
    color: #333;
}
.header-right .el-divider--vertical{
    width: 2px;
    height: 15px;
}
.header-right .el-divider{
    background-color: #333;
}
</style>
